<template>
  <div class="page_top page_bg">
    <div class="page_text_protocol" style="font-size: 12px;">
      <h3>家长监护</h3>
      <br>
      <div class="s_title">家长监护机制</div>
      <dl>
        <dt>一、介绍</dt>
        <dd>
          <p>“家长监护机制”针对目前未成年人缺乏自控及自律能力,容易陷入沉迷；少数监护人缺少时间照顾孩子,不能及时监督孩子游戏时间的现状,而推出的一种可由家长实施监控,纠正部分未成年子女沉迷游戏的保护机制。</p>
        </dd>
      </dl>
      <dl>
        <dt>二、供申请监督方式</dt>
        <dd>
          <p>A. 屏蔽账号：根据监护人意愿屏蔽相关游戏应用登陆。</p>
          <p>B. 账号动态监控：登陆、修改密码等操作将发短信至监护人手机。</p>
          <p>&nbsp;1）账号已经有认证手机的，将监护人手机替换为认证手机；</p>
          <p>&nbsp;2）账号未认证手机，将监护人手机绑定成认证手机；</p>
        </dd>
      </dl>
      <dl>
        <dt>三、其他要求</dt>
        <dd>
          <p>1. 申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提供详实资料；</p>
          <p>2. 申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，我司将保留进一步追究法律责任的权利。</p>
        </dd>
      </dl>
      <br>
      <div class="s_title">监护申请流程</div>
      <dl>
        <dt>一、流程介绍</dt>
        <dd style="text-align: center;">
          <img src="/static/img/fcm_liucheng.jpg" :style="{ width: imgWidth }">
        </dd>
      </dl>
      <dl>
        <dt>二、申请条件</dt>
        <dd>
          <p>1、 申请人需为被监护未成年人的法定监护人；</p>
          <p>2、 申请人的被监护人年龄小于18周岁；</p>
          <p>3、 申请人需为大陆公民，不含港、澳、台人士。</p>
        </dd>
      </dl>
      <dl>
        <dt>二、申请方式</dt>
        <dd>
          <p>1. “客服中心”联系网站客服，咨询申请材料发送方式。</p>
          <p>2. 申请书下载，及填写</p>
          <p> 附件一：<a href="/down/doc/被监护人信息表明书.doc">被监护人信息表明书</a></p>
          <p> 附件二：<a href="/down/doc/家长监护申请书.doc">家长监护申请书</a></p>
          <p> 附件三：<a href="/down/doc/监护人信息表明书.doc">监护人信息表明书</a></p>
        </dd>
      </dl>
      <dl>
        <dt>三、申请时需提供如下资料</dt>
        <dd>
          <p>1、监护人信息、监护人的身份证明复印件；</p>
          <p>2、被监护人信息表、被监护人所玩游戏相关信息及身份证明复印件；</p>
          <p>3、网络游戏未成年人家长监护申请书、保证书、授权书；</p>
          <p>4、申请人与被监护人的监护关系证明文件复印件（户口簿或有关机关出具的证明文件）。</p>
        </dd>
      </dl>
      <dl>
        <dt>四、其他要求</dt>
        <dd>
          <p>1. 申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提供详实资料；</p>
          <p>2.申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，我司将保留进一步追究法律责任的权利。</p>
        </dd>
      </dl>
      <br>
      <div class="s_title">常见问题解答</div>
      <dl>
        <dt>1、Q：可以通过什么渠道申请家长监督未成年人账号？</dt>
        <dd>
          <p>A：您可以通过客服电话前来咨询，并在网页上下载申请资料，填写后传真给客服。</p>
        </dd>
      </dl>
      <dl>
        <dt>2、Q：申请监护未成年人账号方式有哪些？</dt>
        <dd>
          <p>A： 所有账号纳入防沉迷系统；以下方式可以任选：</p>
          <p>1、屏蔽账号（根据申请人意愿屏蔽个别游戏应用）；</p>
          <p>2、账号动态监控</p>
        </dd>
      </dl>
      <dl>
        <dt>3、Q：申请监督的账号有什么要求？</dt>
        <dd>
          <p>A：账号所属人必须未满18周岁。</p>
        </dd>
      </dl>
      <dl>
        <dt>4、Q：申请人有什么要求？</dt>
        <dd>
          <p>A： 1、申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提供详实资料；</p>
          <p>A： 2、申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，受理公司将保留进一步追究法律责任的权利。</p>
        </dd>
      </dl>
      <dl>
        <dt>5、Q：申请监督未成年人账号需要提供什么？</dt>
        <dd>
          <p>A：您需要提供监护人身份证复印件、账号所属人身份证复印件以及户口本复印件、如双方户籍不在一起，需要提供公安机关监护证明、被监护人信息表、监护人信息表的复印件</p>
        </dd>
      </dl>
      <dl>
        <dt>6、Q：申请人提交申请后，多久可以处理完成？</dt>
        <dd>
          <p>A：我们将以最快的速度进行核实处理，由于您提供的材料不同，任何步骤有疑问，我们都会与您联系。</p>
        </dd>
      </dl>
      <dl>
        <dt>7、Q：申请成功后，如果需要取消监督如何操作？</dt>
        <dd>
          <p>A： 1、您可以通过上门或在线提交的形式提供申请监督时的相关信息，申请解除监督；</p>
          <p>A： 2、被监护账号所属人年满18周岁可提供申请监督时的相关信息进行申请结束监督。</p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import tools from '../tools/tools'

export default {
  name: 'JiaZhangMobile',
  components: {},
  mounted () {
    this.onToTop()
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  },
  computed: {
    imgWidth () {
      if (tools.isMoble()) {
        return '95%'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.s_title {
  font-weight: bold;
  font-size: 0.8rem;
}
</style>
